import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
              Hipobuy Sheet Editorial
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              Expert guides, comparisons, and safety tips to level up your product research
            </p>
          </div>
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors"
          >
            Read All Guides <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Beginner Guide Card */}
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-colors hover:bg-background-200/70"
          >
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20white%20desk%20with%20colorful%20sticky%20notes%20in%20neon%20pink%20green%20and%20yellow%20surrounding%20a%20laptop%20screen%20displaying%20organized%20spreadsheet%20data%2C%20bright%20morning%20sunlight%20from%20window%20with%20potted%20succulent%20plant%2C%20creative%20productivity%20workspace%20photography%2C%20vibrant%20accent%20colors%20on%20white%20background%2C%20fresh%20energetic%20editorial%20aesthetic&width=800&height=500&seq=article-guide-v2&orientation=landscape"
                alt="Hipobuy Spreadsheet complete beginner guide"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-2">Beginner Guide</span>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                Complete Hipobuy Spreadsheet Guide 2026
              </h3>
              <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
                Everything beginners need to know — from first-time setup to advanced searching. A step-by-step walkthrough of the entire platform.
              </p>
              <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3">
                Read Guide <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          {/* VS Comparison Card */}
          <Link
            to="/hipobuy-spreadsheet-vs-kakobuy"
            className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-colors hover:bg-background-200/70"
          >
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Split%20screen%20creative%20concept%20with%20two%20contrasting%20product%20displays%2C%20left%20side%20coral%20orange%20themed%20accessories%20on%20white%20surface%2C%20right%20side%20mint%20green%20themed%20items%20on%20gray%20surface%2C%20bright%20balanced%20studio%20lighting%2C%20visual%20comparison%20editorial%20photography%2C%20complementary%20color%20contrast%2C%20modern%20clean%20composition&width=800&height=500&seq=article-vs-v2&orientation=landscape"
                alt="Hipobuy Spreadsheet vs Kakobuy comparison"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2">Comparison</span>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                Hipobuy vs Kakobuy Spreadsheet
              </h3>
              <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
                Detailed side-by-side comparison across categories, update frequency, and user experience. Find out which platform wins for your needs.
              </p>
              <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3">
                Read Comparison <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          {/* Safety Guide Card */}
          <Link
            to="/hipobuy-spreadsheet-safety"
            className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-colors hover:bg-background-200/70"
          >
            <div className="h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20security%20concept%20with%20glowing%20green%20checkmark%20shield%20hovering%20above%20a%20smartphone%20on%20clean%20white%20desk%2C%20soft%20natural%20daylight%2C%20modern%20trust%20and%20safety%20editorial%20photography%2C%20fresh%20green%20and%20white%20color%20palette%2C%20reassuring%20protective%20aesthetic%2C%20minimal%20clean%20composition%20with%20negative%20space&width=800&height=500&seq=article-safety-v2&orientation=landscape"
                alt="Hipobuy Spreadsheet safety and security guide"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">Safety &amp; Security</span>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                Is Hipobuy Spreadsheet Safe?
              </h3>
              <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
                Complete security guide with a 10-step safe shopping checklist. Learn how to verify links, spot red flags, and protect your privacy.
              </p>
              <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3">
                Read Safety Guide <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}